import { isArray } from "lodash";

class Helper{
    static wordLimiter = (text, len)=>{
        if(!text) return '';
        let truncateText = text.split(" ").splice(0,len).join(" ");
        return truncateText.length < text.length ? `${truncateText}...`:truncateText;
    }

    static getUrlParam = (paramName)=>{
        let request = window.location.search,
        urlParams = new URLSearchParams(request);
        return urlParams.get(paramName);
    }
    static generateFilters = ()=>{
        let request=window.location.search,
        urlParams=new URLSearchParams(request),
        params=urlParams.keys(),data=[];
        for(let a of params){
            let r=urlParams.get(a),
            e=r.split(",");
            data.push({[a]:e});
        }
        return data;
    }
    static queryStringToArray = () =>{
        let request=window.location.search,
        urlParams=new URLSearchParams(request),
        params=urlParams.keys(),data=[];
        for(let a of params){
            let r=urlParams.get(a);
            data.push({[a]:r});
        }
        return data;
    }
    
    static getUrlParamKeys = ()=>{
        let request=window.location.search,
        urlParams=new URLSearchParams(request);
        return urlParams.keys();
    }

    static getLastSegmentUrl = ()=>{
        let url = window.location.pathname;
        return url.substr(url.lastIndexOf('/')+1); 
    }

    static createQueryString = (data)=> {
        let queryStringArray = [];
        data.forEach(elem => {
            let name = Object.keys(elem)[0];
            let value = isArray(elem[name]) ? 
            elem[name].join(','):elem[name]
            value &&
            queryStringArray.push([`${name}=${value}`]);
        });
        
        return queryStringArray.join('&');
    }

    static countDown = (endTime)=>{
        var countDownDate = new Date(`${endTime}`).getTime();
        // Update the count down every 1 second
        var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance / (1000 * 60 * 60)));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        hours = hours < 10 ? "0"+hours : hours;
        minutes = ("0" + minutes).slice(-2);
        seconds = ("0" + seconds).slice(-2);
        if (distance < 0) {
            clearInterval(x);
            hours = minutes = seconds = "00";
        }
        if (typeof(document.getElementById("countdown-timer-2")) != 'undefined' && document.getElementById("countdown-timer-2") != null) 
        { 
            document.getElementById("countdown-timer-2").innerHTML = 
            `<small class="countdown-hour">`+hours+`</small>:<small class="countdown-minutes">`+minutes+`</small>:<small class="countdown-second">`+seconds+`</small>`;
        }
        }, 1000);
    }

    static getSiteUrl() {
        return window.siteUrl;
    }

    static setSiteUrl(developmentUrl, productionUrl, isProduction) {
        var adminUrl = developmentUrl;
        if(isProduction) {
            adminUrl = productionUrl;
        }
        window.siteUrl = adminUrl;
    }

    static youtubeParser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    static getYoutubeVideoThumbnail(url) {
        let id = this.youtubeParser(url);
        return `https://img.youtube.com/vi/${id}/0.jpg`;
    }
}
export default Helper